/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateRackShelfRequest } from './update-rack-shelf-request';


export interface UpdateRackRequest { 
    id?: string;
    number?: number;
    description?: string | null;
    subnet?: string | null;
    socketTypeId?: number;
    shelves?: Array<UpdateRackShelfRequest> | null;
}

